import { render, staticRenderFns } from "./ProvinsiPopup.vue?vue&type=template&id=45cc71db&scoped=true"
import script from "./ProvinsiPopup.vue?vue&type=script&lang=js"
export * from "./ProvinsiPopup.vue?vue&type=script&lang=js"
import style0 from "./ProvinsiPopup.vue?vue&type=style&index=0&id=45cc71db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc71db",
  null
  
)

export default component.exports